import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ReactComponent as IconSearch } from '../../../../assets/images/search-in-square.svg';
import { togglePopup } from '../../../../store/ui';
import Button, { ButtonKind } from '../button/Button';
import './index.scss';

const NotSearchResult = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    return (
        <div className="not-search-result__wrapper">
            <div className="not-search-result">
                <IconSearch />

                <h4>
                    {intl.formatMessage({
                        id: 'location.notSearchResult.title',
                        defaultMessage: 'Es gibt derzeit keine Ergebnisse für diesen Standort',
                    })}
                </h4>

                <p>
                    {intl.formatMessage({
                        id: 'location.notSearchResult.subTitle',
                        defaultMessage: 'Bitte versuchen Sie es mit einem anderen Ort oder wählen Sie andere Filter aus',
                    })}
                </p>

                <Button
                    kind={ButtonKind.INVERT}
                    onClick={() => dispatch(togglePopup({ name: 'location_filter', status: true }))}
                >
                    {intl.formatMessage({ id: 'location.notSearchResult.button', defaultMessage: 'Filter öffnen' })}
                </Button>
            </div>
        </div>
    );
};

export default NotSearchResult;
